import { render, staticRenderFns } from "./ProductComparison.vue?vue&type=template&id=3152952e"
import script from "./ProductComparison.vue?vue&type=script&lang=js"
export * from "./ProductComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports